import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 15000 });

export const createBooking = (payload) => api.post("/bookings", payload).then((r) => r.data);
export const listBookings = () => api.get("/bookings").then((r) => r.data);
export const deleteBooking = (id) => api.delete(`/bookings/${id}`).then((r) => r.data);
export const createContact = (payload) => api.post("/contacts", payload).then((r) => r.data);
export const listContacts = () => api.get("/contacts").then((r) => r.data);
export const getStats = () => api.get("/stats").then((r) => r.data);
